import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.starts-with.js";
import Cookies from 'js-cookie';
import { getDomainName } from 'utils/deploymentInfo';
var clearCognitoCookies = function clearCognitoCookies() {
  // This is in place to avoid deleting cookies used by the ui for ssr when running locally.
  // Locally, the domain used both by amplify and by these old cookies to delete
  // is the same: "localhost"
  //
  // More in depth explanation: https://github.com/parsebio/ui/pull/665#issue-3797567639
  var isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
  if (isLocalhost) return;
  var domainName = getDomainName();
  var allCookieKeys = Object.keys(Cookies.get());
  var cognitoCookieKeys = allCookieKeys.filter(function (key) {
    return key.startsWith('CognitoIdentityServiceProvider.');
  });
  cognitoCookieKeys.forEach(function (key) {
    Cookies.remove(key, {
      domain: domainName,
      path: '/',
      secure: true,
      sameSite: 'Strict'
    });
  });
};
export default clearCognitoCookies;